<template>
    <Notification
        :icon="notificationState.icon.value"
        :message="notificationState.message.value"
        :visible="notificationState.visible.value"
        :isPersistent="notificationState.isPersistent.value"
        :isImportant="notificationState.isImportant.value"
        :duration="notificationState.duration.value"
        :count="notificationState.count.value"
        @dismiss="notificationState.dismiss"
    />
</template>

<script setup>
import Notification from "@/components/notification/Notification.vue";
import {notificationState} from '@/services/notification.js';
</script>